var render = function render(){var _vm=this,_c=_vm._self._c;return _c('user-picker',{staticClass:"cup",attrs:{"value":_vm.objects,"title":_vm.title,"type":"partners","multiple":_vm.multiple,"disabled":_vm.disabled,"height":40},on:{"input":_vm.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }